module.exports = "<nav class=\"navbar navbar-fixed-top navbar-default\" ng-class=\"{scroll: (scroll>10)}\">\r\n  <div class=\"container\">\r\n    <div class=\"navbar-header pull-left\">\r\n        <player-controls />\r\n    </div>\r\n    \r\n    <div class=\"navbar-header pull-right\">\r\n        <a href=\"/login\" data-activates=\".sidebar\">Login</a>\r\n    </div>\r\n  </div>\r\n</nav>";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/html/top_nav.html
 ** module id = 46
 ** module chunks = 0
 **/